import { FC } from 'react';

import styles from './SkipButton.module.scss';
type SkipButtonProps = {
  onClick: () => void;
  variant?: 'primary' | 'secondary';
};
export const SkipButton: FC<SkipButtonProps> = ({ onClick, variant = 'primary' }) => {
  return (
    <button className={[styles.button, styles[`--${variant}`]].join(' ')} onClick={onClick}>
      スキップ
    </button>
  );
};
